export enum ContentListType {
  ForYou = "[Frontend] HomeForYou",
  MostPopular = "[Frontend] HomeMostPopular",
  LiveSessions = "[Frontend] HomeLiveSessions",
  Sessions = "DiscoverSessions",
  LiveSchedule = "DiscoverLiveSchedule",
  QuickReads = "DiscoverQuickReads",
  RecentlyAdded = "DiscoverRecentlyAdded",
  HeroCarousel = "DiscoverHighlighted",
}
